import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { CompetitionPlayer } from './competition-player'
import { competitionPlayerActions } from './competition-player.actions'
import * as fromCompetitionPlayer from './competition-player.reducer'
import { CompetitionPlayerService } from './competition-player.service'

@Injectable()
export class CompetitionPlayerEffects extends ResourceEffects<CompetitionPlayer> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public competitionPlayerService: CompetitionPlayerService
  ) {
    super(
      fromCompetitionPlayer.FEATURE_NAME,
      competitionPlayerService,
      competitionPlayerActions,
      actions$
    )
  }
}
